module.exports = __webpack_public_path__ + "img/file-upload.c23dadcf.svg";